import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { savePDF } from "../service/uploadService";
import { editPDF, editPDFUnLock, pdfRenameDocument } from "../service/editPDF";
export const editPDFsLock = createAsyncThunk(
  "/edit",
  async (id, { rejectWithValue }) => {
    try {
      const response = await editPDF(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editPDFsunLock = createAsyncThunk(
  "/edit",
  async (id, { rejectWithValue }) => {
    try {
      const response = await editPDFUnLock(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const autoSavePDF = createAsyncThunk(
  "/autosave",
  async ({ id, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await savePDF(id, file);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const pdfRenameDocuments = createAsyncThunk(
  "/rename",
  async ({ id, newPDFName }, { rejectWithValue }) => {
    try {
      const response = await pdfRenameDocument(id, newPDFName);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Auth slice
const editPDFSlice = createSlice({
  name: "editPDF",
  initialState: {
    isAuthenticated: false,
    user: null,
    error: null,
    showActions: true,
  },
  reducers: {
    updateShowActions(state, action) {
      state.showActions = action.payload;
    },
  },
});

export const { updateShowActions } = editPDFSlice.actions;
export default editPDFSlice.reducer;
